import { Sanitizer, Validator, Definition, ParsedValue } from '@common';

/**
 * 格式化单个单元格数据
 * https://github.com/exceljs/exceljs/blob/master/README_zh.md
 *
 * Null = 0 - 空单元格
 * Merge = 1 - 合并单元格的一部分
 * Number = 2
 * String = 3
 * Date = 4
 * Hyperlink = 5 - 超链接
 * Formula = 6 - 公式
 * SharedString = 7 - 共享字符串的引用
 * RichText = 8 - 富文本
 * Boolean = 9
 * Error = 10 - 错误
 */
export class Parser {

  private readonly sanitizer = new Sanitizer();
  private readonly validator = new Validator();

  async parse(rows: string[][], definitions: Definition[], rowNumber: number, colNumber: number): Promise<ParsedValue> {
    const cell = rows[rowNumber][colNumber];
    const definition = definitions[colNumber];

    const value: ParsedValue = {
      text: cell ?? '',
      value: null,
      error: new Set<string>()
    };

    // 如果有默认值，设置默认值
    if (definition.defaults != null) {
      value.text = definition.defaults.toString();
    }

    const option = {
      rowNumber,
      colNumber,
      rows,
      definitions
    };

    // 校验数据
    await this.validator.check(value, option);

    // 如果校验通过，进行数据处理
    if (value.error.size <= 0) {
      await this.sanitizer.parse(value, definition);
    }

    return value;
  }

}
